function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.5 19.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff"
    },
    d: "M4.375,0H.625A.6.6,0,0,0,0,.563V3.938A.6.6,0,0,0,.625,4.5h3.75A.6.6,0,0,0,5,3.938V.563A.6.6,0,0,0,4.375,0Zm0,6.751H.625A.6.6,0,0,0,0,7.313v3.375a.6.6,0,0,0,.625.563h3.75A.6.6,0,0,0,5,10.689V7.313A.6.6,0,0,0,4.375,6.751Zm0,6.751H.625A.6.6,0,0,0,0,14.064v3.375A.6.6,0,0,0,.625,18h3.75A.6.6,0,0,0,5,17.439V14.064A.6.6,0,0,0,4.375,13.5Zm15-6.751H8.125a.6.6,0,0,0-.625.563v3.375a.6.6,0,0,0,.625.563h11.25A.6.6,0,0,0,20,10.689V7.313A.6.6,0,0,0,19.375,6.751Zm0-6.751H8.125A.6.6,0,0,0,7.5.563V3.938a.6.6,0,0,0,.625.563h11.25A.6.6,0,0,0,20,3.938V.563A.6.6,0,0,0,19.375,0Zm0,13.5H8.125a.6.6,0,0,0-.625.563v3.375A.6.6,0,0,0,8.125,18h11.25A.6.6,0,0,0,20,17.439V14.064A.6.6,0,0,0,19.375,13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContents);
export default __webpack_public_path__ + "static/media/contents.071f99f62c78a5c2a688d754d49f59ee.svg";
export { ForwardRef as ReactComponent };